import React from 'react';
import { noop } from 'lodash';

export default function renderProp(render, fallback = null, argument = {}) {
    if (React.isValidElement(render)) return render;

    const isValidFunction = typeof render === 'function' && render !== noop;
    const result = isValidFunction ? render(argument) : null;

    if (![false, null, undefined].includes(result)) return result;
    if (typeof fallback === 'function') return fallback(argument);
    return fallback;
}
